import { BroadcastTypes, DialogDetails } from './types';

export const broadcastTypes: BroadcastTypes = {
  live: {
    id: 1,
    name: 'Live',
    description: 'A talk, panel, or webinar with a live speaker or speakers'
  },
  preRecorded: {
    id: 2,
    name: 'Pre-recorded',
    description: 'An event with no live speakers'
  },
  rtmp: {
    id: 3,
    name: 'RTMP',
    description: 'A live streaming event that originates outside of Goldcast'
  }
};

export const dialogTypeMapping: {
  [key: string]: DialogDetails;
} = {
  session: {
    dialogTitleOnCreate: 'Create Session',
    dialogTitleOnEdit: '',
    inputTitle: 'Session Title',
    inputTitlePlaceholder: 'My Awesome Session',
    primaryActionTitle: { default: 'Create', loading: 'Creating...' }
  },
  break: {
    dialogTitleOnCreate: 'Add a Break to Your Agenda',
    dialogTitleOnEdit: 'Edit Break',
    inputTitle: 'Break Title',
    inputTitlePlaceholder: '30 Minute Break',
    primaryActionTitle: { default: 'Create', loading: 'Creating...' }
  },
  room: {
    dialogTitleOnCreate: 'Add a Room Block to Your Agenda',
    dialogTitleOnEdit: 'Edit Room',
    inputTitle: 'Agenda Title',
    inputTitlePlaceholder: 'Go To Rooms',
    primaryActionTitle: { default: 'Create', loading: 'Creating...' }
  },
  booth: {
    dialogTitleOnCreate: 'Add a Booth Block to Your Agenda',
    dialogTitleOnEdit: 'Edit Booth',
    inputTitle: 'Agenda Title',
    inputTitlePlaceholder: 'Go To Booths',
    primaryActionTitle: { default: 'Create', loading: 'Creating...' }
  }
};

export const booths = [
  {
    id: 0,
    text: 'Primary Booths'
  },
  {
    id: 1,
    text: 'Secondary Booths'
  }
];

export const sessionTypes = [
  {
    id: 0,
    text: 'Live',
    disabled: false,
    disabledTooltip: ''
  },
  {
    id: 1,
    text: 'Pre-recorded',
    disabled: false,
    disabledTooltip: ''
  },
  {
    id: 2,
    text: 'RTMP',
    disabled: false,
    disabledTooltip: ''
  }
];

export const REGEX_TO_VALIDATE_URL = new RegExp(
  '^rtmps?:\\/\\/[a-zA-Z0-9.-]+(:\\d{1,5})?(\\/[\\/a-zA-Z0-9.-]+)?\\/?$',
  'i'
);

export const SESSION_BUFFER_START_TIME = 10; //in minutes

export const NON_SESSION_BUFFER_START_TIME = 1; // in minutes
